// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".has-border-bottom-grey-light[data-v-338046da]{border-bottom:1px solid #dbdbdb}.color-tertiary[data-v-338046da]{color:#2cd5c4}.color-primary[data-v-338046da]{color:#ef4a81}.color-grey-darker[data-v-338046da]{color:#363636}.color-grey[data-v-338046da]{color:#7a7a7a}.help.is-danger[data-v-338046da]{position:static}.has-text-danger[data-v-338046da]{font-size:12px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
